import { weakMapMemoize } from '@reduxjs/toolkit';

function merge<A extends Record<string, unknown>, B extends Record<string, unknown>>(first: A, second: B): A & B;
function merge<T extends Record<string, unknown>>(first: T | undefined, second: T | undefined): T;
function merge(first: object, second: object): object {
  if (first != null && second == null) return first;
  if (first == null && second != null) return second;
  return { ...first, ...second };
}

/**
 * Merges two objects and caches the merged result so that
 * whenever called with exactly the same array instances, it will return the cached
 * array instance. Used for performance & memory optimization. Use this only when you can guarantee
 * that this function is called with exactly the parameters often.
 */
const mergeCached = weakMapMemoize(merge);

export default mergeCached;
